import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("ccs_token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ccs_token");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("ccs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    localStorage.setItem("ccs_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const loginWithToken = (token, userData) => {
    localStorage.setItem("ccs_token", token);
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem("ccs_token");
    setUser(null);
  };

  const updateProfile = async (payload) => {
    const { data } = await api.put("/auth/profile", payload);
    setUser(data);
    return data;
  };

  const toggleWishlist = async (slug) => {
    if (!user) throw new Error("auth");
    const { data } = await api.post("/wishlist/toggle", { product_id: slug });
    setUser((u) => ({ ...u, wishlist: data.wishlist }));
    return data.active;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithToken, logout, updateProfile, toggleWishlist, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}
